import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import { Game } from '../../../../../Core'
import * as MapSelectors from '../../../map.selectors'
import * as PhaseSelectors from '../../../../Phases/phases.selectors'
import * as MapActions from '../../../map.actions'
import * as battlesActions from '../../../../Battles/battles.actions'
import * as indicatorsSelectors from '../../../../Indicators/indicators.selectors'

import BuildingListInfo from './BuildingListInfo'

const mapStateToProps = (state) => {
  return {
    buildings: MapSelectors.getBuildings(state),
    attacking: MapSelectors.getAttackState(state),
    selectedTile: MapSelectors.getSelectedTile(state),
    currentPhase: PhaseSelectors.getCurrentPhase(state),
    visitorMap: MapSelectors.getVisitorMap(state),
    visitorInfo: MapSelectors.getVisitorInfo(state),
    userMap: MapSelectors.getUserMap(state),
    parameters: MapSelectors.getBuildingParameters(state),
    userData: indicatorsSelectors.getUserData(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
    createBuilding: bindActionCreators(MapActions.createBuilding, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BuildingListInfo))
